import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as PR from '../prime-modules/index';
import * as Yup from 'yup';
import { useFormik } from "formik";
import { verifyemail } from "../services/api";
import { authActions } from "../store/auth";
import { useToast } from "../context/ToastContext";

const VerifyEmail = (props) => {
  const dispatch = useDispatch();
  const { showToast, labels } = useToast();

  const idPath = useSelector(state => state.auth.idPath);
  const affiliateTrackingData = useSelector(state => state.affiliateTracking.affiliateTrackingInfo);
  const isLoggedIn = useSelector(state =>  state.auth.isLoggedIn);
  const [userIdCleared, setUserIdCleared] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const headers = useMemo(() => {
      return {afid: affiliateTrackingData};
  }, [affiliateTrackingData]);

  useEffect(() => {
    if (!idPath.userId && !userIdCleared) {
      showToast('error', 'SIGNUP-11')
    }

  }, [showToast, userIdCleared, idPath.userId])

  const formInitialValues = {
    otp: '',
  };

  const validationSchema = () => {
    return Yup.object().shape({
      otp: Yup.string().trim()
        .required(labels.LBL0049)
        .min(6, labels.LBL0050)
        .max(6, labels.LBL0050)
        .matches(/^[0-9\b]+$/, labels.LBL0051)
    });
  }

  const submitHandler = (formData) => {
    setDisableBtn(true);
    const getResponse = (response) => {
      if (response.result === "SUCCESS") {
        showToast('success', 'SIGNUP-12')
        formik.resetForm();
        setUserIdCleared(true); // Mark userId as intentionally cleared
        setTimeout(() => {
          dispatch(authActions.deleteStoreIdPath());
          props.renderFormState(!isLoggedIn, (isLoggedIn ? "" : "login"))
        }, 2000);
      } else {
        const error = response.error;
        showToast(error.severity, error.errorMsg);
      }
      setDisableBtn(false);
    }

    const otpVal = formData.otp.trim();
    const otpRequest = {
      userId: idPath.userId,
      code: otpVal
    }

    const apiUrl = (idPath.pathName === "verify-email") ? 'verifyemail' : 'updateemail';
    verifyemail(otpRequest, apiUrl, headers, dispatch, getResponse)
  }
  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: validationSchema,
    onSubmit: submitHandler
  });

  return (
    <>
      <div className="form-section forgot-password-section">
          <div className="form">
              <h3>{labels.LBL0045}</h3>
              <p>{labels.LBL0046}</p>
              <form onSubmit={formik.handleSubmit} autoComplete="off">
                  <div className="input-field">
                    <PR.InputText id="otp" name="otp" placeholder={labels.LBL0048} className="w-12" value={formik.values.otp} onChange={formik.handleChange} onBlur={formik.handleBlur} autoComplete="off" />
                    {formik.errors.otp && formik.touched.otp
                      ? <div className='error-message'>{formik.errors.otp}</div>
                      : ''
                    }
                  </div> 
                  <PR.Button label={labels.LBL0047} type='submit' disabled={disableBtn} className="login-btn signup-btn" />
              </form>
          </div>
      </div>
    </>
  );
};

export default VerifyEmail;